import React, {useContext} from 'react';
import './ModalTaskUpdateShow.css'
import {FriendContext} from "../../App";

const ModalTaskUpdateShow = () => {

    const {closeTask, setCloseTask} = useContext(FriendContext)


    return (
        <div className="m__t__u__a__b">
            {closeTask.map(task =>
                <div key={task.id} className="m__t__u__s" onClick={e => e.stopPropagation()}>
                    <div className="m__t__u__t">Созданая вами задача <b>"{task.name}"</b> под номером <b>{task.id}</b> выполнена</div>
                    <div className="m__t__u__c">
                        <div className="cl-btn-6" >
                            <div className="cl-btn-6-in">
                                <div onClick={() => setCloseTask([])} className="cl-btn-6-txt">Закрыть</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ModalTaskUpdateShow;